import { render } from "./fisFooter.vue?vue&type=template&id=ea3263c2&scoped=true&ts=true"
import script from "./fisFooter.vue?vue&type=script&lang=ts"
export * from "./fisFooter.vue?vue&type=script&lang=ts"

import "./fisFooter.vue?vue&type=style&index=0&id=ea3263c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea3263c2"]])

export default __exports__